import { render, staticRenderFns } from "./userspecialdiet.vue?vue&type=template&id=740e71f8&scoped=true"
import script from "./userspecialdiet.vue?vue&type=script&lang=js"
export * from "./userspecialdiet.vue?vue&type=script&lang=js"
import style0 from "./userspecialdiet.vue?vue&type=style&index=0&id=740e71f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e71f8",
  null
  
)

export default component.exports